import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Accueilsection from "../components/sections/Accueilsection";
import Apropos from "../components/sections/Apropos";
import Contact from "../components/sections/Contact";
import Service from "../components/sections/Service";
import Temoignage from "../components/sections/Temoignage";
import ServiceRequestForm from "../components/sections/ServiceRequestForm";
import FumoirGallery from "../components/sections/FumoirGallery";

export default function Accueil() {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location.hash]);

    return (
        <div>
            <Accueilsection id="accueil" />
            <Apropos id="Apropos" />
            <Service id="Service" />
            <FumoirGallery />
            <Temoignage id="Temoignage" />
            <ServiceRequestForm />{" "}
            {/* Assurez-vous d'avoir un ID si vous voulez y lier un menu */}
            <Contact id="Contact" />
        </div>
    );
}
